<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>
            Movimentação
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>
        <mat-card>
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-1">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>ID</mat-label>
                  <input formControlName="id" matInput readonly>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Conta Origem</mat-label>
                  <mat-select id="caixaOrigen" name="caixaOrigen" [(value)]="caixaOrigen">
                    <mat-option [value]="box.id" *ngFor="let box of boxsAtivo">{{box.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-label>Conta Destino</mat-label>
                  <mat-select id="caixaDestino" name="caixaDestino" [(value)]="caixaDestino">
                    <mat-option [value]="''"></mat-option>
                    <mat-option [value]="box.id" *ngFor="let box of boxsAtivo">{{box.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-2">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Valor Movimentação</mat-label>
                  <span matPrefix>R$ &nbsp;</span>
                  <input matInput formControlName="valorMovimentacao"
                    currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" required>
                </mat-form-field>
              </div>
              <div class="col-3" *ngIf="caixaDestino === ''">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Tipo de Movimentação</mat-label>
                  <mat-select formControlName="tipoMovimentacao">
                    <mat-option value="ENTRADA">Entrada</mat-option>
                    <mat-option value="SAIDA">Saida</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                  <mat-label>Observacao</mat-label>
                  <textarea formControlName="observacao" matInput placeholder="Observacao"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="wow-form-acoes">
              <button type="button" mat-stroked-button (click)="voltarConsulta()">
                <mat-icon>arrow_back</mat-icon> Voltar
              </button>
              <button type="button" (click)="limparFormulario()" mat-stroked-button>
                <mat-icon>insert_drive_file</mat-icon> Limpar
              </button>
              <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                <mat-icon>save</mat-icon> Salvar
              </button>
            </div>
          </form>
          <div class="esp-top">
            <div *ngIf="formulario.controls.observacao.errors && !formulario.controls.observacao.pristine"
              class="alert alert-warning" role="alert">
              Campo nome deve conter entre 3 e 50 caracteres!
            </div>
          </div>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
